const ragflowBaseUrl: string | undefined =
	process.env.REACT_APP_RAGFLOW_BASE_URL ?? 'https://airflow.air-4you.xyz';
const ragflowApiKey: string | undefined =
	process.env.REACT_APP_RAGFLOW_API_KEY ?? 'ragflow-E5MmQ3YzcwMzYzNjExZjBiMzYyOGE0OD';

if (!ragflowBaseUrl || !ragflowApiKey) {
	console.error('ragflowBaseUrl', ragflowBaseUrl);
	console.error('ragflowApiKey', ragflowApiKey);
	throw new Error('RAGFLOW_BASE_URL and RAGFLOW_API_KEY must be set');
}

const APP_BASE_URL = '';

export { ragflowBaseUrl as RAGFLOW_BASE_URL, ragflowApiKey as RAGFLOW_API_KEY, APP_BASE_URL };
